import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M5.15376 19.0008H6.39028L15.65 9.74111L14.4134 8.50456L5.15376 17.7642V19.0008ZM18.8576 8.65651L15.4826 5.31234L17.8653 2.92969L21.2248 6.28924L18.8576 8.65651ZM3.65381 20.5007V17.1258L14.398 6.38154L17.773 9.75649L7.02873 20.5007H3.65381Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map